"use strict";

exports.__esModule = true;
exports.default = uploadPic;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
var _util = require("./util");
var _utils = require("../utils");
/* eslint-disable no-use-before-define */

var zzMedia = _utils.isServer || location.origin.includes('zhuanzhuan.com') || location.origin.includes('caihuoxia.com') || location.origin.includes('m.zhuanspirit.com') ? 'https://mediaproxy.zhuanzhuan.com/media/picture/upload' : 'https://mediaproxy.zhuanspirit.com/media/picture/upload';
function uploadPic(file, options, changeHandler) {
  var target = options.target,
    _options$headers = options.headers,
    headers = _options$headers === void 0 ? {} : _options$headers,
    _options$data = options.data,
    data = _options$data === void 0 ? {} : _options$data,
    _options$fileName = options.fileName,
    fileName = _options$fileName === void 0 ? 'file' : _options$fileName,
    withCredentials = options.withCredentials,
    timeout = options.timeout,
    _options$prop = options.prop,
    prop = _options$prop === void 0 ? 'file' : _options$prop,
    _options$progressInte = options.progressInterval,
    progressInterval = _options$progressInte === void 0 ? 100 : _options$progressInte,
    _options$checkSuccess = options.checkSuccess,
    checkSuccess = _options$checkSuccess === void 0 ? function () {
      return true;
    } : _options$checkSuccess;
  var realTarget = (0, _util.evalOpts)(target, file);
  if (!realTarget || realTarget.includes('//upload.58cdn.com.cn/json')) {
    realTarget = zzMedia;
  }
  file.progress = 0;
  file.status = _util.STATUS_UPLOADING;
  var xhr = new window.XMLHttpRequest();
  // eslint-disable-next-line no-underscore-dangle
  file._xhr = xhr;
  var progressTid = 0;
  if (xhr.upload) {
    var lastProgressTime = Date.now();
    xhr.upload.onprogress = function (e) {
      if (e.total > 0) {
        if (progressTid) {
          clearTimeout(progressTid);
          var now = Date.now();
          var diff = now - lastProgressTime;
          if (diff >= progressInterval) {
            computed();
          } else {
            progressTid = setTimeout(computed, diff);
          }
        } else {
          // first time
          computed();
          progressTid = 1;
        }
      }
      function computed() {
        file.progress = e.loaded / e.total;
        lastProgressTime = Date.now();
      }
    };
  }
  var formData = '';
  // 默认的形成
  // if (options.zz) {
  //   // 转转的base64模式
  //   formData = JSON.stringify({
  //     'Pic-Data': file.base64 && file.base64.replace(/data.*;base64,/, ''),
  //     'Pic-Size': '0',
  //     'Pic-Encoding': 'base64',
  //     'Pic-Path': '/zhuanzh/',
  //   });
  if (realTarget === zzMedia) {
    formData = new window.FormData();
    var realData = (0, _util.evalOpts)(Object.assign({
      path: '/zhuanzh/'
    }, data), file);
    Object.keys(realData).forEach(function (key) {
      formData.append(key, realData[key]);
    });
    // jpg后缀的图片开启服务端压缩
    // if (/\.jpg/.test(file.name)) {
    //   formData.append('outputQuality', '0.5');
    //   formData.append('outputFormat', 'jpg');
    // }
    formData.append('multipartFile', file[prop]);
  } else {
    formData = new window.FormData();
    var _realData = (0, _util.evalOpts)(data, file);
    Object.keys(_realData).forEach(function (key) {
      formData.append(key, _realData[key]);
    });
    formData.append(fileName, file[prop]);
  }
  xhr.onload = function () {
    // 上传失败
    if (xhr.status < 200 || xhr.status >= 300) {
      setStatus(_util.STATUS_ERROR);
      return;
    }

    // 上传成功，却没有返回（一般是zz参数设错了）
    if (!xhr.responseText && !xhr.response) {
      setStatus(_util.STATUS_ERROR);
      return;
    }
    if (realTarget === zzMedia) {
      var response = JSON.parse(xhr.responseText || xhr.response);
      if (+response.respCode !== 0) {
        setStatus(_util.STATUS_ERROR);
        return;
      }
      setResponse(response.respData);
    } else {
      setResponse(xhr.responseText || xhr.response);
    }
    if (checkSuccess.length <= 2) {
      var isSuccess = checkSuccess(file.response, file);
      setStatus(isSuccess ? _util.STATUS_SUCCESS : _util.STATUS_ERROR);
    } else {
      // callback
      checkSuccess(file.response, file, function (isSuccess) {
        setStatus(isSuccess ? _util.STATUS_SUCCESS : _util.STATUS_ERROR);
      });
    }
  };
  xhr.onerror = function () {
    setStatus(_util.STATUS_ERROR);
  };
  xhr.ontimeout = function () {
    setStatus(_util.STATUS_ERROR);
  };
  xhr.open('POST', realTarget, true);
  if (withCredentials || realTarget === zzMedia) {
    xhr.withCredentials = true;
  }
  var realHeaders = (0, _util.evalOpts)(headers, file);
  Object.keys(realHeaders).forEach(function (key) {
    xhr.setRequestHeader(key, realHeaders[key]);
  });
  if (timeout > 0) {
    xhr.timeout = timeout;
  }
  xhr.send(formData);
  function setStatus(status) {
    clearTimeout(progressTid);
    progressTid = 0;
    file.progress = 1;
    file.status = status;
    changeHandler && changeHandler(file);
  }
  function setResponse(response) {
    var random = Math.ceil(Math.random() * 6);
    file.response = realTarget === zzMedia ? 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + response : response;
    file.url = realTarget === zzMedia ? 'https://pic' + random + '.zhuanstatic.com/zhuanzh/' + response : '';
    file.responseHeaders = xhr.getAllResponseHeaders();
    file.urlName = response;
  }
}